import type { RatingCaptionProps } from './types';
import React from 'react';
import Text, { TEXT_VARIANT } from '@pixum/text';
import { replaceDynamicConstantByObject } from 'utils';

export function RatingCaption({ count, rating, constant }: RatingCaptionProps) {
  const text = replaceDynamicConstantByObject(constant, { count: count?.toString() });
  const caption = `${rating.toFixed(1) || 5} (${text})`;

  return <Text variant={TEXT_VARIANT.CAPTION}>{caption}</Text>;
}
